<ng-container *ngFor="let tag of tags">
    <ion-badge (click)="openTag(tag)" class="core-tag-list-tag" role="link">{{ tag.rawname }}</ion-badge>
</ng-container>
